import {ChangeDetectionStrategy, Component, Inject, Input} from '@angular/core';

require("./text-copy-button.scss");
@Component({
  standalone: false,
  selector: 'app-text-copy-button',
  templateUrl: './text-copy-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCopyButtonComponent {

  @Input() text: string;
  @Input() showText: boolean;
  @Input() isShowCopyBtn: boolean = false;
  @Input() isShowAlways: boolean = false;

  constructor(@Inject('bringozToastService') private bringozToastService) {
  }

  copyToClipboard(event) {
    event.stopPropagation();
    window.navigator.clipboard.writeText(this.text).then(()=>{
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }
}
